/**
 * Extracts the neighborhood from an address in the Google/app format.
 * Expected format: "<street>, <number> - <neighborhood>, <city> - <state>, <zip>, <country>".
 * The neighborhood is the segment after the first " - ", up to the next comma.
 *
 * @param {string} address full address
 * @returns {string} neighborhood, or '' if it cannot be extracted
 */
export const extractNeighborhood = (address) => {
  if (!address || typeof address !== 'string') return ''

  const dashIndex = address.indexOf(' - ')
  if (dashIndex === -1) return ''

  const afterDash = address.slice(dashIndex + 3)
  return afterDash.split(',')[0].trim()
}
